import EDC from '@/components/games/shared/globals';
import CursorManager from '@/components/games/shared/cursor-manager';
import store from '@/store';
import Button from '@/components/games/shared/button';
/**
 *
 */
EDC.Games.ProfileSummary.Scenes.Main = function () {};
/**
 *
 */
EDC.Games.ProfileSummary.Scenes.Main.prototype.init = function () {
  this.bg = null;
  this.content = null;
  this.cursorManager = null;
  this.createButton = null;
  this.backButton = null;
  this.createClicked = false;
  this.logo = null;
  this.scale.off('resize', this.resize, this);
};
/**
 *
 */
EDC.Games.ProfileSummary.Scenes.Main.prototype.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);
  this.cursorManager.resetCursor();

  this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'profile-summary-background');

  this.content = this.add.container();

  const frame = this.add.sprite(0, 200, 'profile-summary-frame').setOrigin(0);

  const titleBg = this.add.sprite(frame.x + frame.displayWidth / 2 + 50, 50, 'profile-summary-title-bg');
  titleBg.displayWidth += 30;
  const title = this.add.sprite(titleBg.x, titleBg.y, 'profile-summary-title');

  this.logo = this.add.sprite(0, 0, 'logo');
  this.logo.init_scale = 1;

  this.createButton = new Button(this, frame.x + frame.displayWidth / 2, 450).create(
    'profile-summary-create-btn-normal',
    'profile-summary-create-btn-hover',
  );
  this.createButton.setClickCallback(this.createProfile.bind(this));

  this.backButton = new Button(this, frame.x + frame.displayWidth / 2, 650).create(
    'profile-summary-back-btn-normal',
    'profile-summary-back-btn-hover',
  );
  this.backButton.setClickCallback(this.changeProfileSettings.bind(this));

  const newChildProfile = store.getters['children/newChildProfile'];
  this.gradeValue = newChildProfile.grade;
  this.genderValue = newChildProfile.gender;
  this.avatarValue = newChildProfile.avatar;
  this.nameValue = newChildProfile.nickname;

  // grade
  const gradeBg = this.add.image(frame.x + 170, frame.y + frame.displayHeight / 2 + 25, 'grade-selection-answer-back');
  const gradeFrame = this.add.image(gradeBg.x, gradeBg.y, 'grade-selection-answer-frame');
  const gradeImg = this.add.sprite(gradeBg.x, gradeBg.y, `grade-selection-grade-${this.gradeValue}`);

  // gender
  const genderBg = this.add.image(gradeBg.x + 220, gradeBg.y, 'grade-selection-answer-back');
  const genderFrame = this.add.image(genderBg.x, genderBg.y, 'grade-selection-answer-frame');
  let genderImg = null;
  if (this.genderValue === 'boy') {
    genderImg = this.add.image(genderBg.x, genderBg.y, 'profile-summary-gender-boy');
  } else {
    genderImg = this.add.image(genderBg.x, genderBg.y, 'profile-summary-gender-girl');
  }

  // avatar
  const avatarBg = this.add.image(gradeBg.x + 450, gradeBg.y, 'grade-selection-answer-back');
  const avatarFrame = this.add.image(avatarBg.x, avatarBg.y, 'grade-selection-answer-frame');
  const avatarImg = this.add.sprite(avatarBg.x, avatarBg.y, `avatar-${this.avatarValue}`).setScale(0.37);

  // nickname
  const name = this.add
    .text(avatarFrame.x + 130, gradeBg.y, this.nameValue, { fontFamily: 'Font006AllCapsBW', fontSize: 90 })
    .setOrigin(0, 0.5);
  frame.displayWidth += name.displayWidth / 3 - 80;

  // titles
  const font = {
    font: '40px Arial',
    color: '#A9A9A9',
  };
  const gradeTitle = this.add.text(gradeBg.x - 90, frame.y + 80, 'GRADE', font).setOrigin(0, 0.5);
  const genderTitle = this.add.text(genderBg.x - 90, frame.y + 80, 'GENDER', font).setOrigin(0, 0.5);
  const avatarTitle = this.add.text(avatarBg.x - 90, frame.y + 80, 'AVATAR', font).setOrigin(0, 0.5);
  const nicknameTitle = this.add.text(name.x, frame.y + 80, 'NICKNAME', font).setOrigin(0, 0.5);

  titleBg.x -= 30;
  this.content.add([
    frame,
    titleBg,
    title,
    gradeBg,
    gradeFrame,
    gradeImg,
    genderBg,
    genderFrame,
    genderImg,
    avatarBg,
    avatarFrame,
    avatarImg,
    name,
    gradeTitle,
    genderTitle,
    avatarTitle,
    nicknameTitle,
  ]);

  this.cursorManager.setDefaultDraggableEvents(this.createButton.getContainer());
  this.cursorManager.setDefaultDraggableEvents(this.backButton.getContainer());

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });
};
/**
 *
 */
EDC.Games.ProfileSummary.Scenes.Main.prototype.createProfile = function () {
  if (this.createClicked) return;
  this.createClicked = true;

  store.dispatch('children/createChild', {
    grade: this.gradeValue,
    gender: this.genderValue,
    avatar: this.avatarValue,
    nickname: this.nameValue,
  })
    .then(() => this.scene.start('profileCreated'))
    .finally(() => (this.createClicked = false));
};
/**
 *
 */
EDC.Games.ProfileSummary.Scenes.Main.prototype.changeProfileSettings = function () {
  this.scene.start('mainName');
};
/**
 *
 */
EDC.Games.ProfileSummary.Scenes.Main.prototype.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;

  this.cameras.resize(width, height);

  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);

  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.5) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition((width - bounds.width) / 2,
    height / 2 - bounds.height + 150 * neededScale);

  this.createButton.setScale(neededScale);
  this.createButton.setPosition(this.content.x + bounds.width / 2,
    this.content.y + 700 * neededScale);

  this.logo.setScale(this.logo.init_scale * neededScale);
  this.logo.setPosition(this.content.x + bounds.width / 2 - 710 * neededScale,
    this.content.y + 60 * neededScale);

  this.backButton.setScale(neededScale);
  this.backButton.setPosition(this.content.x + bounds.width / 2 - 82 * neededScale,
    this.content.y + 900 * neededScale);
};

export default EDC.Games.ProfileSummary.Scenes.Main;
